import React from 'react';
import Header from "../../../Components/Header/Header";
import { LeftSettings } from '../LeftSettings';
import LeftMenu from '../../../Components/LeftMenu/LeftMenu';

export const RegionSettings = () => {

  const SBack = localStorage.getItem('SettingsBack');

  return (
    <>
      {/* <div className="">
        <Header logo_url={SBack ? SBack : '/ULDControl'} sBackUrl={SBack ? SBack : '/ULDControl'} />
        <div className="page-body-wrapper schedule">
        <LeftMenu />
        <div className="main-panel">

          <div className="row">

            <LeftSettings /> */}
            <div className='col-9 col-xxl-9 stting_right'>
              <div className='settingbg_right'>
                <h4>Region Settings</h4>
                <p>Set your notification preferences for when you are in or away from the dashboard.</p>

              </div>
            </div>
          {/* </div>

        </div>
        </div>
      </div> */}
    </>
  )
}

export default RegionSettings